export default __webpack_public_path__ + "static/media/loading.69326f6f.svg";